import React from "react";
import { Switch } from "react-router-dom";

import { LazyRoute } from "components/Common/LazyRoute";

const SSOLoginCallback = React.lazy(() =>
  import("components/Declarative/Pages/Login/SSOLoginCallback").then(
    (module) => ({
      default: module.SSOLoginCallback,
    }),
  ),
);
const PasswordSet = React.lazy(
  () => import("components/Declarative/Pages/PasswordSet"),
);
const Login = React.lazy(() => import("components/Declarative/Pages/Login"));

export const UnauthenticatedContainer = () => (
  <Switch>
    <LazyRoute path="/login/callback" component={SSOLoginCallback} />
    <LazyRoute path="/users/password/set/:token" component={PasswordSet} />
    <LazyRoute path="*" component={Login} />
  </Switch>
);
